// api
let api, passportUrl, wifiEnUrl, bannerConfigUrl, wifiJSPCUrl, wifiNationPCUrl, JiProtryUrl, staticBaseUrl, newMgmBaseUrl;

let env = process.env.REACT_APP_ENV;
if (process.env.REACT_APP_ENV === 'production') {
    // 生产环境
    api = 'https://portalapi.huazhu.com';
    wifiEnUrl = 'https://haowifi.huazhu.com/enlogin.html';
    bannerConfigUrl = api + '/api/handle/bannerConfig?activityId=commonLogoWallConfig';
    wifiJSPCUrl = 'https://haowifi.huazhu.com/pchomejiangsu.html?param=';
    wifiNationPCUrl = 'https://haowifi.huazhu.com/pchome.html?param=';
    JiProtryUrl = 'https://quanjipoem.huazhu.com/entry/';
    staticBaseUrl = 'https://campaign.huazhu.com/static/2019';
    newMgmBaseUrl = 'https://newmgm.huazhu.com'; // 赠卡页
} else if (process.env.REACT_APP_ENV === 'preview') {
    // 预发布环境
    // api = 'https://portalapi.huazhu.com:8443';
    api = 'https://portalapi.huazhu.com';
    wifiEnUrl = 'https://haowifi.huazhu.com/enlogin.html';
    bannerConfigUrl = api + '/api/handle/bannerConfig?activityId=commonLogoWallConfig';
    wifiJSPCUrl = 'https://haowifi.huazhu.com/pchomejiangsu.html?param=';
    wifiNationPCUrl = 'https://haowifi.huazhu.com/pchome.html?param=';
    JiProtryUrl = 'https://quanjipoem.huazhu.com/entry/';
    staticBaseUrl = 'https://campaign.huazhu.com/static/preview';
    newMgmBaseUrl = 'https://newmgm.huazhu.com'; // 赠卡页
} else {
    // api = 'http://10.100.249.18:8443'; //开发环境
    api = 'https://test-wifiapi.huazhu.com'; //测试环境
    // api = 'https://portalapi-preview.huazhu.com';//预生产环境
    // api = 'http://10.105.242.98:30008'; //本地
    // api = 'http://10.106.89.28:30008'; //思源本地
    // api = 'http://10.106.89.35:30008/'; //孙闯本地
    // api = 'http://10.106.89.228:30008/'; //廖磊本地
    wifiEnUrl = 'https://test-haowifi.huazhu.com/enlogin.html';
    bannerConfigUrl = api + '/api/handle/bannerConfig?activityId=commonLogoWallConfig';
    wifiJSPCUrl = 'https://test-haowifi.huazhu.com/pchomejiangsu.html?param=';
    wifiNationPCUrl = 'https://test-haowifi.huazhu.com/pchome.html?param=';
    JiProtryUrl = 'https://test-quanjipoem.huazhucorp.com/entry/';
    staticBaseUrl = 'https://test-campaign.huazhu.com'; // 静态资源站
    newMgmBaseUrl = 'https://test-newmgm.huazhucorp.com'; // 赠卡页
}

export { api, passportUrl, wifiEnUrl, bannerConfigUrl, wifiJSPCUrl, wifiNationPCUrl, JiProtryUrl, staticBaseUrl, newMgmBaseUrl };
